module.exports = __webpack_public_path__ + "img/manmangongsi.b921ee76.png";